<template>
  <div class="overlay-gradient" :class="`overlay-gradient--${type}`"></div>
</template>

<script setup>
defineProps({
  type: {
    type: String,
    default: 'gradient',
    validator: (value) => ['uniform', 'gradient', 'radial', 'none'].includes(value)
  },
  opacity: {
    type: Number,
    default: 0.4
  }
})
</script>

<style scoped>
.overlay-gradient {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  pointer-events: none;
}

.overlay-gradient--uniform {
  background: rgba(0, 0, 0, 0.4);
}

.overlay-gradient--gradient {
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.7) 0%,
    rgba(0, 0, 0, 0.2) 50%,
    rgba(0, 0, 0, 0.7) 100%
  );
}

.overlay-gradient--radial {
  background: radial-gradient(
    circle at center,
    rgba(0, 0, 0, 0.2) 0%,
    rgba(0, 0, 0, 0.6) 100%
  );
}

.overlay-gradient--none {
  background: none;
}
</style>
